// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import documentTemplateEntity from './entities/document-template.json';
import documentTemplateMenu from '../pages/document-template/menu.json';
import documentTemplateFullForm from '../pages/document-template/forms/full.json';
import documentTemplateContextForm from '../pages/document-template/forms/context.json';
import documentTemplateMiniForm from '../pages/document-template/forms/mini.json';
import documentTemplateLookupForm from '../pages/document-template/forms/lookup.json';
import documentTemplateTableView from '../pages/document-template/views/table.json';
import documentTemplateDashboardView from '../pages/document-template/views/dashboard.json';

/** Тип запису «Шаблон документа» зі сторінками пакета: меню, форми та подання з pages/document-template/. */
export const documentTemplateDefinition: IRecordTypeDefinition = {
  ...documentTemplateEntity,
  views: assembleViewSet({
      table: documentTemplateTableView,
      dashboard: documentTemplateDashboardView,
  }),
  form: documentTemplateFullForm,
  forms: { full: documentTemplateFullForm, context: documentTemplateContextForm, mini: documentTemplateMiniForm, lookup: documentTemplateLookupForm },
  menu: documentTemplateMenu,
} as IRecordTypeDefinition;
